import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderPrepareStand from "../../../../src/content/prepare-to-stand/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderPrepareStand,
  React
};